<div class="betting-game {{ colorScheme.main }}" (click)="onClick()">
  <div class="title">
    <mat-icon>edit</mat-icon>
    <h3>Wie geht das Spiel aus?</h3>
  </div>
  <div class="betting-game-content">
    <div class="team">
      <img [src]="matchService.teams.home.pictures | imageUrlBySubtype" alt="Team Logo"/>
      <span>{{ matchService.teams.home.name }}</span>
    </div>
    <div class="input-fields">
      <input type="text"/>
      <input type="text"/>
    </div>
    <div class="team">
      <img [src]="matchService.teams.away.pictures | imageUrlBySubtype" alt="Team Logo"/>
      <span>{{ matchService.teams.away.name }}</span>
    </div>
  </div>
  <button class="send-tip" (click)="onClick()">Tipp abgeben</button>
</div>
